import { ReactNode } from "react";

/* Prop Types */
interface TableProps {
  children: ReactNode;
}

/*
 * Table component
 */
export const Table = ({ children }: TableProps) => {
  /* Render */
  return (
    <div className="grow max-h-full">
      <table className="relative w-full table-fixed">{children}</table>
    </div>
  );
};
